import { AlphaLCircleOutlineIcon } from './AlphaLCircleOutlineIcon';

/**
 * author: Contributors
 * id F62EB8C2-6037-474B-8D48-FD635163D3A6
 * name alpha-l-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-l-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetLCircleOutlineIcon = AlphaLCircleOutlineIcon;
export default AlphabetLCircleOutlineIcon